<template>
  <div>
    <div class="datanull">
      <img
        v-if="noneListhint.istype == 'book'"
        src="~img/personal/notwrite.png"
        alt=""
      />
      <img
        v-if="noneListhint.istype == 'notice'"
        src="~img/notice.png"
        alt=""
      />
      <p>{{ noneListhint.msg }}</p>
      <a
        v-if="noneListhint.isbtn"
        class="btn"
        href="javaScript:"
        @click="goelse"
        >{{ noneListhint.btnmsg }}</a
      >
    </div>
  </div>
</template>

<script>
// import { setAbookid, settoll } from "utils/storage";
export default {
  props: {
    noneListhint: {
      type: Object,
      default: function() {
        return {
          msg: "您还没有写过书，快来发布第一本大作吧！",
          btnmsg: "创建作品",
          isbtn: true,
          istype: "book"
        };
      }
    }
  },
  methods: {
    goelse() {
      this.$emit("elseUrl", true);
    }
  }
};
</script>
<style lang="stylus" scoped>
.datanull {
    padding 10vh 0
}
</style>
